export const JuChainId = 210000
